export default __webpack_public_path__ + "static/media/closet2-1920w.62712184.avif";